import { QueryKey, useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

import { queryClient } from '../../configs/queryClient';

async function cancel(axios: AxiosInstance, workshopUpdateRequestId: number): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/workshop-update-request/${workshopUpdateRequestId}/cancel`);
  return data;
}

export default function useCancelWorkshopUpdateRequestMutation(workshopUpdateRequestId: number, queryKey: QueryKey) {
  const axios = useAxios();

  return useMutation({
    mutationFn: () => cancel(axios, workshopUpdateRequestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
